import config from "../../common/config";
import AjaxHelper from "../../common/js/AjaxHelper";
class SubjectService {
    async getAccountBrandStoreForSelect() {
        const url = `${config.BASE_Middle_API}SubjectDetails/GetAccountBrandStoreForSelect`;
        var rs = await AjaxHelper.get(url);
        return rs.result;
    }

    async getAccountConfInfosForSelect() {
        const url = `${config.BASE_Middle_API}AccountConfInfosUser/GetListForSelect`;
        var rs = await AjaxHelper.get(url);
        return rs.result;
    }

    async getBrandForSelect(input) {
        const url = `${config.BASE_Middle_API}BussinessBrandInfo/GetListByAccountConfIDForSelect`;
        var rs = await AjaxHelper.get(url, input);
        return rs.result;
    }

    async getSubjectTypesForTree(input) {
        const url = `${config.BASE_Middle_API}SubjectTypeUsers/GetKeyValuesForSelect`;
        var rs = await AjaxHelper.get(url, input);
        return rs.result;
    }

    async getSubjectFields(input) {
        const url = `${config.BASE_Middle_API}SubjectFieldUsers/GetAllForSelect`;
        var rs = await AjaxHelper.get(url, input);
        return rs.result;
    }

    async getSubjectDetails(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/GetAllForSelect`;
        var rs = await AjaxHelper.get(url, input);
        return rs.result;
    }

    async getOppositeSubjects(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/OppositeSubjects`;
        var rs = await AjaxHelper.get(url, input);
        return rs.result;
    }

    async getSubjectFieldDataForSelect(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/SubjectFieldDataForSelect`;
        var rs = await AjaxHelper.post(url, input);
        return rs.result;
    }

    async save(inputs) {
        const url = `${config.BASE_Middle_API}SubjectDetails/CreateOrUpdateList`;
        var rs = await AjaxHelper.post(url, inputs);
        return rs;
    }
    async excelImport(inputs) {
        const url = `${config.BASE_Middle_API}SubjectDetails/ExcelImport`;
        var rs = await AjaxHelper.post(url, inputs);
        return rs;
    }
    async deleteInfo(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/Delete`;
        var rs = await AjaxHelper.delete(url, input);
        return rs;
    }

    async batchDeleteInfo(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/BatchDelete`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }

    async getSubjectRelationTree(input) {
        const url = `${config.BASE_Middle_API}SubjectRelations/GetSubjectRelationTree`;
        var rs = await AjaxHelper.get(url, input);
        return rs.result;
    }

    async copy(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/CopySubject`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }

    async quicklyCopy(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/QuicklyCopySubjectToOthers`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }
    async subjectAllCoverage(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/SubjectAllCoverage`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }
    async batchSetRedMark(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/BatchSetRedMark`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }

    async batchSetBlueMark(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/BatchSetBlueMark`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }

    async batchSetCredit(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/BatchSetCredit`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }

    async getDetails(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/GetDetails`;
        var rs = await AjaxHelper.get(url, input);
        return rs.result;
    }

    async showFieldSave(input) {
        const url = `${config.BASE_Middle_API}SubjectFieldShows/CreateOrEdit`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }

    async checkComplateGo(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/CheckDataComplate`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }
    async checkInComeComplateGo(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/CheckInComeDataComplate`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }
    async syncAddItemType(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/SyncAddItemType`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }
    async checkSubjectGo(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/CheckSubjectResult`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }
    async ReplaceSubjectInfo(input) {
        const url = `${config.BASE_Middle_API}SubjectDetails/ReplaceSubjectInfo`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }
}
export default new SubjectService();
